import localStorage from 'localStorage'

export default function getCurrentRestaurantId () {

	return localStorage.getItem('currentRestaurantId')

}
